document.addEventListener('DOMContentLoaded', () => {
  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const searchCheckoutButtonElement = async () => {
    for (let i = 0; i < 50; i++) {
      const checkoutButtonElement = document.querySelector('#update-cart');
      if (checkoutButtonElement) {
        console.log('チェックアウトボタンが見つかりました'); // デバッグログ
        return checkoutButtonElement;
      }
      await sleep(100);
    }
    return null;
  };

  searchCheckoutButtonElement().then(checkoutButton => {
    if (checkoutButton) {
        event.preventDefault(); // フォーム送信を一時的に無効化
        console.log('ボタンクリックが検出されました'); // デバッグログ

        // 1.5秒後にdisabledを解除
        setTimeout(() => {
          checkoutButton.disabled = false; 
          console.log('disabledが解除されました'); // デバッグログ

        }, 1500);
    } else {
      console.log('チェックアウトボタンが見つかりません');
    }
  });
});